import { Box } from "@mui/material";

const SplashScreen = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      bgcolor: "#ffffff",
    }}
  >
    <img src="/logo512.png" alt="The Helm logo" />
  </Box>
);

export default SplashScreen;
